import { gql } from "apollo-boost"

export const DELETE_INDICATORS = gql`
  mutation deleteIndicators ($indicatorIds: [ID!]!) {
    deleteIndicators(indicatorIds: $indicatorIds)
  }
`
